import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { VideoReportReason } from 'src/app/models/video-report-reason';
import { UiService } from 'src/app/services/ui.service';
import { VideoService } from 'src/app/services/video.service';

@Component({
	selector: 'report-media-modal',
	templateUrl: './report-media-modal.component.html',
	styleUrls: ['./report-media-modal.component.scss']
})
export class ReportMediaModalComponent implements OnInit {

	@ViewChild('submitButton') submitButton;
	@ViewChild('option') option;
	@Output() closeModal = new EventEmitter<void>();
	@Input() elementFocusCallback: () => void;
	@Input() mediaId: number;

	reason: string;

	reasons: VideoReportReason[] = [];


	constructor(private ui: UiService,
		private videoService: VideoService) { }

	async ngOnInit() {
		let reasonList = await this.videoService.getReportReasons(this.mediaId).toPromise().then((x) => {
			return Object(x);
		});

		let length = Object.keys(reasonList).length;

		for (let r = 0; r < length; r++) {
			this.reasons.push({tag: Object.keys(reasonList)[r].toString(), text: Object.values(reasonList)[r].toString() });
		}
	}

	ngOnDestroy() {
		this.elementFocusCallback();

	}

	close() {
		this.closeModal.emit();
	}

	ok() {
		this.videoService.reportMedia(this.mediaId, { reason: this.reason }).subscribe(() => {
			this.closeModal.emit();
		});
	}

	selectReason(reason: string) {
		this.submitButton.nativeElement.focus();
		this.reason = reason;
	}

    voidKey($event: KeyboardEvent, i: number = 0) {
        if (i === 0) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    }
}
